import React from "react";

export default function TermsText() {
  return (
    <div style={{ fontSize: 14, lineHeight: 1.6 }}>
      <h2>Termos e Condições de Uso e Política de Privacidade – FinBot</h2>
      <p>
        <strong>Última atualização:</strong> 01/2025
      </p>

      <h3>1. O que é o FinBot</h3>
      <p>
        O FinBot é uma plataforma de apoio à tomada de decisão financeira
        pessoal. O FinBot não é corretora, banco, consultor financeiro, gestor
        de recursos ou serviço de execução automática de ordens.
      </p>

      <h3>2. Natureza das informações</h3>
      <p>
        As informações, análises, alertas e classificações exibidas têm caráter
        informativo e educacional e não constituem recomendações personalizadas
        de investimento. As decisões de investimento são de responsabilidade
        exclusiva do usuário.
      </p>

      <h3>3. Riscos e ausência de garantias</h3>
      <p>
        Investimentos envolvem riscos. Resultados passados não garantem resultados
        futuros. O FinBot não garante lucro, desempenho positivo ou proteção
        contra perdas. O serviço pode apresentar atrasos, imprecisões ou
        indisponibilidades temporárias.
      </p>

      <h3>4. Política de Privacidade (LGPD)</h3>
      <p>
        O FinBot trata dados pessoais em conformidade com a LGPD (Lei nº 13.709/2018),
        coletando apenas o necessário para operação do serviço, personalização da
        experiência, comunicação e cumprimento de obrigações legais.
      </p>

      <h4>4.1 Dados coletados</h4>
      <ul>
        <li>Dados cadastrais (ex.: e-mail);</li>
        <li>Dados de uso do aplicativo;</li>
        <li>Informações inseridas voluntariamente (ex.: ativos e operações);</li>
        <li>Dados técnicos (ex.: dispositivo e sistema operacional).</li>
      </ul>

      <h4>4.2 Finalidades</h4>
      <ul>
        <li>Operação e funcionamento do aplicativo;</li>
        <li>Geração de análises, alertas e relatórios;</li>
        <li>Melhoria do serviço e suporte;</li>
        <li>Cumprimento de obrigações legais.</li>
      </ul>

      <p>
        <strong>O FinBot não vende dados pessoais.</strong>
      </p>

      <h4>4.3 Compartilhamento</h4>
      <p>
        Os dados podem ser compartilhados apenas quando necessário para operação
        técnica (ex.: infraestrutura e notificações), para cumprimento legal, ou com
        prestadores essenciais sob obrigações de confidencialidade.
      </p>

      <h4>4.4 Direitos do usuário</h4>
      <p>
        Você pode solicitar acesso, correção, portabilidade (quando aplicável),
        revogação de consentimentos (quando aplicável) e exclusão da conta e dos dados,
        respeitados prazos legais e requisitos de segurança/auditoria.
      </p>

      <h3>5. Atualizações</h3>
      <p>
        Estes Termos e esta Política podem ser atualizados. Em alterações relevantes,
        o usuário poderá ser notificado e um novo aceite poderá ser exigido.
      </p>

      <h3>6. Aceite</h3>
      <p>
        Ao aceitar, você declara que leu, compreendeu e concorda integralmente com
        este documento.
      </p>
    </div>
  );
}
